import Layout from "../../layout";
import "./community.css";
import { useEffect, useState, useRef } from "react";
import Button from "antd/lib/button";
import Ellipse1 from "../../assets/images/Ellipse1.png";
import Ellipse2 from "../../assets/images/Ellipse2.png";
import Ellipse3 from "../../assets/images/Ellipse3.png";
import Avatar from "antd/lib/avatar";
import Avatar3 from "../../assets/images/avatar3.png";
import Avatar4 from "../../assets/images/avatar4.png";
import profilePicture from "../../assets/images/profilePicture.png";
import { FaHeart, FaRegHeart } from "react-icons/fa6";
import { FiMessageCircle } from "react-icons/fi";
import { FaRegTrashAlt } from "react-icons/fa";
import SliderImg from "../../assets/images/sliderImg.png";
import Modal from "antd/lib/modal";
import { IoClose } from "react-icons/io5";
import { IoCloseCircleOutline } from "react-icons/io5";
import TextArea from "antd/lib/input/TextArea";
import { LuImage, LuMessageCirclePlus } from "react-icons/lu";
import { IoIosArrowDown } from "react-icons/io";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/free-mode";
import useCommunity from "../../hooks/use_community";
import { useDispatch, useSelector } from "react-redux";
import showFile from "../../helpers/show_file";
import { setSelectedCourse } from "../../features/community/community_slice";
import LoadingPrimary from "../../assets/animations/loading_primary.svg";
import Empty from "antd/lib/empty";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { dateHelper } from "../../helpers/date_helper";

const Community = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    // entity methods
    getCourses,
    seenCounts,
    getPosts,
    deletePost,
    likePost,
    // controller methods
    createPostController,
    // entity states
    postsData,
    // controller states
    paginates,
    newPostModal,
    setNewPostModal,
    deletePostModal,
    setDeletePostModal,
    selectedPost,
    setSelectedPost,
    // loadings
    loadings,
  } = useCommunity();

  let uploadFileRef = useRef(null);

  const communitySliderArrey = [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1];
  const [deleteCommentModal, setDeleteCommentModal] = useState(false);

  const userProfile = useSelector((state) => state.app.userProfile);
  const courses = useSelector((state) => state.community.courses);
  const selectedCourse = useSelector((state) => state.community.selectedCourse);

  const handleUploadFile = (e) => {
    let array = [...createPostController.values.files];
    let file = e.target.files[0];
    if (file) {
      array.push({
        file: file,
        url: URL.createObjectURL(file),
      });
      createPostController.setFieldValue("files", array);
    }
    e.target.value = null;
  };

  useEffect(() => {
    if (userProfile) {
      if (courses.length == 0) {
        getCourses();
      }
    }
  }, [userProfile]);

  useEffect(() => {
    if (selectedCourse) {
      getPosts(selectedCourse?.id, 1);
      seenCounts(selectedCourse?.id);
    }
  }, [selectedCourse]);

  useEffect(() => {
    if (!newPostModal) {
      createPostController.resetForm();
    }
  }, [newPostModal]);

  return (
    <Layout>
      <section className="community">
        <h3>Community</h3>
        {courses?.length > 0 ? (
          <div className="community_container">
            {/* courses */}
            <div className="community_wrapper">
              <Swiper
                pagination={false}
                slidesPerView={8}
                spaceBetween={8}
                breakpoints={{
                  320: {
                    slidesPerView: 2.8,
                  },
                  400: {
                    slidesPerView: 3.8,
                  },
                  500: {
                    slidesPerView: 4.8,
                  },
                  600: {
                    slidesPerView: 5.8,
                  },
                  700: {
                    slidesPerView: 6.8,
                  },
                  800: {
                    slidesPerView: 7.8,
                  },
                  900: {
                    slidesPerView: 8.8,
                  },
                  1000: {
                    slidesPerView: 5.8,
                  },
                  1100: {
                    slidesPerView: 6.8,
                  },
                  1200: {
                    slidesPerView: 7.8,
                  },
                  1300: {
                    slidesPerView: 8.8,
                  },
                  1400: {
                    slidesPerView: 9.8,
                  },
                  1500: {
                    slidesPerView: 10.8,
                  },
                  1600: {
                    slidesPerView: 11.8,
                  },
                  1700: {
                    slidesPerView: 12.8,
                  },
                  1800: {
                    slidesPerView: 13.8,
                  },
                  1900: {
                    slidesPerView: 14.8,
                  },
                  2000: {
                    slidesPerView: 15.8,
                  },
                }}
              >
                {courses?.map((course, index) => (
                  <SwiperSlide key={index} className="community_slider">
                    <div
                      id={
                        course?.course?.id === selectedCourse?.id
                          ? "active_community_slider_item"
                          : null
                      }
                      className="community_slider_item"
                      onClick={() => {
                        dispatch(setSelectedCourse(course?.course));
                      }}
                    >
                      <div className="image">
                        {course.unreadCount ? (
                          <p className={"badge"}>{course?.unreadCount}</p>
                        ) : null}
                        {course?.course?.banner?.name ? (
                          <img
                            src={showFile(course?.course?.banner?.name)}
                            alt={course?.course?.name}
                          />
                        ) : (
                          <div>
                            {course?.course?.name?.slice(0, 1)?.toUpperCase()}
                          </div>
                        )}
                      </div>

                      <h3>{course?.course?.name}</h3>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
            {/* comments_container */}
            {!loadings.getPosts && postsData?.length > 0 ? (
              <div className={"comments_container"}>
                {postsData?.map((post, index) => (
                  <div key={index} className={"comments_item"}>
                    <div className={"comments_item_left"}>
                      <div>
                        <div>
                          {post?.author?.avatar ? (
                            <img
                              src={showFile(post?.author?.avatar)}
                              alt={post?.author?.fullname}
                            />
                          ) : (
                            <div>
                              {post?.author?.fullname
                                ?.slice(0, 1)
                                ?.toUpperCase()}
                            </div>
                          )}
                        </div>
                        {post?.replies?.length > 0 ? (
                          <div className={"line6"}></div>
                        ) : null}
                        {post?.replies?.length > 0 ? (
                          <div className={"avatar"}>
                            <Avatar.Group
                              maxCount={5}
                              maxStyle={{
                                color: "#fff",
                                backgroundColor: "#1677ff",
                              }}
                            >
                              {post?.replies?.map((reply, replyIndex) => (
                                <Avatar
                                  key={replyIndex}
                                  src={
                                    reply?.author?.avatar ? (
                                      <img
                                        src={showFile(reply?.author?.avatar)}
                                        alt="avatar"
                                      />
                                    ) : (
                                      <div className={"reply_avatar"}>
                                        {reply?.author?.fullname
                                          ?.slice(0, 1)
                                          ?.toUpperCase()}
                                      </div>
                                    )
                                  }
                                />
                              ))}
                            </Avatar.Group>
                          </div>
                        ) : null}
                      </div>
                    </div>
                    <div className={"comments_item_right"}>
                      <div className={"comments_item_right1"}>
                        <h3>{post?.author?.fullname}</h3>
                        <div>
                          <span> {dateHelper(post?.createTime)}</span>
                          {post?.author?.id == userProfile?.id ? (
                            <Button
                              onClick={() => {
                                setDeletePostModal(true);
                                setSelectedPost(post);
                              }}
                            >
                              <FaRegTrashAlt />
                            </Button>
                          ) : null}
                        </div>
                      </div>
                      <p>{post?.text}</p>
                      <div className={"comments_item_right3"}>
                        <Button
                          onClick={() => {
                            likePost(post);
                          }}
                        >
                          {post?.likedByMe ? (
                            <FaHeart style={{ color: "var(--red)" }} />
                          ) : (
                            <FaRegHeart />
                          )}
                          {post?.likeCount}
                        </Button>
                        <Button
                          onClick={() => {
                            navigate(`/community/${post?.id}`);
                          }}
                        >
                          <FiMessageCircle />
                          {post?.replyCount}
                        </Button>
                      </div>
                      {post?.images?.length > 0 ? (
                        <div
                          className={`${"gallery_container"} ${
                            post?.images.length === 1
                              ? "grid_1"
                              : post?.images?.length === 2
                                ? "grid_2"
                                : post?.images?.length === 3
                                  ? "grid_3"
                                  : "grid_4plus"
                          }`}
                        >
                          {post?.images?.map((image, imageIndex) => (
                            <Link
                              to={showFile(image?.name)}
                              target="_blank"
                              key={imageIndex}
                            >
                              <img src={showFile(image?.name)} alt="review" />
                            </Link>
                          ))}
                        </div>
                      ) : null}
                    </div>
                    <div
                      onClick={() => {
                        navigate(`/community/${post?.id}`);
                      }}
                    ></div>
                  </div>
                ))}
              </div>
            ) : null}
            {!loadings.getPosts && postsData?.length == 0 ? (
              <div className="comments_container_empty">
                <Empty description="No posts have been uploaded yet." />
                <div
                  onClick={() => {
                    setNewPostModal(true);
                  }}
                >
                  Create your first post <FaPlus />
                </div>
              </div>
            ) : null}
            {loadings.getPosts ? (
              <div className="get_posts_loading">
                <img src={LoadingPrimary} alt="Loading..." />
              </div>
            ) : null}
            {/* pagination */}
            {paginates.has_more ? (
              <div className={"pagination"}>
                {loadings.getPostsPaginate ? (
                  <img
                    src={LoadingPrimary}
                    width={20}
                    height={20}
                    alt="Loading..."
                  />
                ) : (
                  <div
                    onClick={() => {
                      getPosts(selectedCourse?.id, paginates.current + 1);
                    }}
                  >
                    Load more posts
                  </div>
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        {loadings.getCourses ? (
          <div className="community_courses_loading">
            <img src={LoadingPrimary} alt="Loading..." />
          </div>
        ) : null}
        {!loadings.getCourses && courses?.length == 0 ? (
          <div className="community_courses_empty">
            <Empty description={"You haven't created any courses yet."} />
            <Link to={"/courses/new"}>
              Create your first course <FaArrowRight />
            </Link>
          </div>
        ) : null}
        {/* new post button */}
        {selectedCourse ? (
          <div className={"share_btn"}>
            <Button
              onClick={() => {
                setNewPostModal(true);
              }}
            >
              <LuMessageCirclePlus />
              <span>Share Your Thoughts</span>
            </Button>
          </div>
        ) : null}
      </section>
      {/* new post modal */}
      <Modal
        open={newPostModal}
        onCancel={() => {
          setNewPostModal(false);
        }}
        footer={null}
        className="sharetModal"
        closeIcon={null}
      >
        <form
          onSubmit={createPostController.handleSubmit}
          className="share_modal_container"
        >
          <div className="share_modal_title">
            <Button
              onClick={() => {
                setNewPostModal(false);
              }}
              disabled={loadings.createPost}
            >
              <IoClose />
            </Button>
            <h3>New post or question</h3>
          </div>
          <h3>Share your thoughts</h3>
          <TextArea
            name="text"
            id="text"
            value={createPostController.values.text}
            onChange={createPostController.handleChange}
            disabled={loadings.createPost}
            status={
              createPostController.touched.text &&
              createPostController.errors.text
                ? "error"
                : ""
            }
            placeholder="Write your post or question here"
            rows={7}
          />
          <div className="add_btn_share_modal">
            <Button
              htmlType="button"
              disabled={loadings.createPost}
              onClick={() => {
                uploadFileRef.current?.click();
              }}
            >
              <span>
                <LuImage /> Add media
              </span>
            </Button>
            <input
              type="file"
              style={{ display: "none" }}
              onChange={handleUploadFile}
              ref={uploadFileRef}
              accept="image/*"
            />
          </div>
          {createPostController.values.files?.length > 0 ? (
            <div className="create_post_media">
              {createPostController.values.files?.map((item, index) => (
                <div key={index}>
                  <img src={item.url} alt={"Uploaded file"} />
                  <div>
                    <FaRegTrashAlt
                      onClick={() => {
                        if (!loadings.createPost) {
                          let array = [...createPostController.values.files];
                          array = array.filter((o, ind) => ind != index);
                          createPostController.setFieldValue("files", array);
                        }
                      }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : null}
          {/* post_btn */}
          <div className="post_btn">
            <Button loading={loadings.createPost} htmlType="submit">
              Post
            </Button>
            <Button
              disabled={loadings.createPost}
              onClick={() => {
                setNewPostModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete post modal */}
      <Modal
        open={deletePostModal}
        onCancel={() => {
          setDeletePostModal(false);
        }}
        footer={null}
        className="deleteCommentModal"
        closeIcon={null}
      >
        <div className="delete_comment_modal_container">
          <div className="delete_comment_modal_title">
            <Button
              onClick={() => {
                setDeletePostModal(false);
              }}
            >
              <IoClose />
            </Button>
            <IoCloseCircleOutline />
          </div>
          <div>
            <h3>Are you sure you want to delete this post?</h3>
          </div>
          <div className="delete_comment_modal_btn">
            <Button
              onClick={() => {
                deletePost(selectedPost?.id);
              }}
              loading={loadings.deletePost}
            >
              Yes, Delete
            </Button>
            <Button
              onClick={() => {
                setDeletePostModal(false);
              }}
              disabled={loadings.deletePost}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default Community;
